/*
 * Created Date: 26-01-2024, 9:36:52 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Fri Jan 26 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'

class Workspace extends BaseService {
	// BASE_URL = 'https://studio-api-04.eduquiz.io.vn'

	BASE_URL = 'https://studio-api-07.eduquiz.io.vn'

	constructor(params) {
		super(params)
		this.setRequest()
	}

	getCurrentWorkspace = () => {
		const endpoint = `/workspace/studio/api/v1/my-workspace/current`
		return this.request.get(endpoint)
	}

	getMyWorkspaces = () => {
		const endpoint = `/workspace/studio/api/v1/my-workspace/list`
		return this.withCache(() => this.request.get(endpoint), endpoint)
	}

	createWorkspace = data => {
		const endpoint = `/workspace/studio/api/v1/my-workspace/create`
		return this.request.post(endpoint, data)
	}

	updateWorkspace = data => {
		const endpoint = `/workspace/studio/api/v1/my-workspace/update`
		return this.request.put(endpoint, data)
	}

	switchWorkspace = workspace_id => {
		const endpoint = `/workspace/studio/api/v1/my-workspace/switch`
		return this.request.post(endpoint, { workspace_id })
	}

	getProvince = () => {
		const endpoint = 'workspace/public/api/v1/provinces'

		return this.request.get(endpoint)
	}

	sendContact = data => {
		const endpoint = `/core/api/v1/public/contacts`
		return this.request.post(endpoint, data)
	}

	sendWorkspaceContact = data => {
		const endpoint = `/workspace/studio/api/v1/user/contacts`
		return this.request.post(endpoint, data)
	}
}

const workspaceService = new Workspace()

export default workspaceService
